import React, {useEffect, useState} from 'react'
import {FormControl, InputLabel, TextField, Tooltip} from '@mui/material'
import {styled} from '@mui/material/styles'
import {useDispatch} from 'react-redux'
import * as form from '../modules/insurance/healthInsurance/redux/healthInsuranceRedux'
import * as auto from '../modules/insurance/AutoInsurance/redux/autoRedux'
import * as moto from '../modules/insurance/MotoInsurance/redux/motoRedux'
import * as user from '../modules/insurance/healthInsurance/redux/userRedux'
import * as filter from '../redux-commons/FilterRedux/filterRedux'
import * as product from '../modules/insurance/InsuranceProducts/redux/productRedux'
import {CustomInputLable} from './SelectField'
import {validateSpecialChar} from '../utils'
import {reformatText} from '../utils/InputFormatCurrency'

type Props = {
  label: string
  id: string
  inputClass?: string
  inputNumberOnly?: boolean
  maxLength?: number
  name: string
  placehoder: string
  inputReadonly?: boolean
  wrapperClass?: string
  inputValue?: string
  tabName?: string
  formName?: string
  errorText?: string
  required?: boolean
  validateField?: boolean
  formatCurrency?: boolean
  inputUppercase?: boolean
  handleInputChange?: (value: string) => void
  handleBlurInput?: (value: string, name: string) => void
}

export const CustomInputField = styled(TextField)<{styleprops?: {uppercase: string}}>(
  ({theme, styleprops}) => ({
    '& .MuiInputBase-input': {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: '#fff',
      fontSize: 12,
      padding: '9px 8px',
      textTransform: styleprops ? styleprops.uppercase : 'none',
    },
    '& .MuiInputLabel-root': {
      color: '#000 !important',
      transform: 'translate(14px, -9px) scale(0.85)',
      backgroundColor: '#fff',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.1)',
    },
  })
)

export const InputField: React.FC<Props> = ({
  label,
  id,
  inputNumberOnly,
  inputClass,
  maxLength,
  name,
  inputReadonly,
  wrapperClass,
  inputValue,
  tabName,
  formName,
  required,
  validateField,
  handleInputChange,
  handleBlurInput,
  placehoder,
  formatCurrency,
  errorText,
  inputUppercase,
}) => {
  const [value, setValue] = useState('')
  const [labelInput, setLabelInput] = useState('')
  const dispatch = useDispatch()

  const handleSaveData = (event: any) => {
    let value = event.target.value
    let name = event.target.name
    setValue(value.trim())
    if (handleBlurInput) handleBlurInput(value.trim(), name.trim())
    if (formName && formName.toLowerCase().includes('formperson')) {
      let data = {
        key: id,
        value: value.trim(),
        tab: tabName ? tabName : '',
        form: formName ? formName : '',
      }
      dispatch(form.actions.addProductInfo(data))
    } else if (formName && formName.toLowerCase().includes('auto')) {
      let data = {
        key: id,
        value: value.trim(),
        tab: tabName ? tabName : '',
        form: formName ? formName : '',
      }
      dispatch(auto.actions.addAutoInfos(data))
    } else if (formName && formName.toLowerCase().includes('moto')) {
      let data = {
        key: id,
        value: value.trim(),
        tab: tabName ? tabName : '',
        form: formName ? formName : '',
      }
      dispatch(moto.actions.addMotoInfos(data))
    } else if (
      formName &&
      (formName.toLowerCase().includes('product') ||
        formName.toLowerCase().includes('cargo') ||
        formName.toLowerCase().includes('marine') ||
        formName.toLowerCase().includes('property') ||
        formName.toLowerCase().includes('micro'))
    ) {
      let data = {
        key: id,
        value: value.trim(),
        tab: tabName ? tabName : '',
        form: formName ? formName : '',
      }
      dispatch(product.actions.addProductInfos(data))
    } else if (formName && formName.toLocaleLowerCase().includes('filter')) {
      let data = {
        field: id ? id : '',
        value: value,
        filterForm: formName,
      }
      dispatch(filter.actions.updateFilterInfo(data))
    } else if (formName === 'user') {
      let data = {
        key: id,
        value: value.trim(),
      }
      dispatch(user.actions.addUserInfo(data))
    }
  }

  const handleChangeData = (event: any) => {
    if (!event.nativeEvent.data && !event.nativeEvent?.inputType) {
      handleSaveData(event)
    }
    if (inputNumberOnly) {
      const re = /^[0-9\b,. ]+$/
      if (event.target.value === '' || re.test(event.target.value)) {
        setValue(event.target.value)
        if (handleInputChange) handleInputChange(event.target.value)
      }
    } else {
      let test = validateSpecialChar(event.target.value)
      if (
        !test &&
        !id.toLocaleLowerCase().includes('address') &&
        !id.toLocaleLowerCase().includes('name')
      )
        event.target.value = event.target.value.replaceAll(',', '')
      setValue(event.target.value)
      if (handleInputChange) handleInputChange(event.target.value)
    }
  }

  useEffect(() => {
    if (inputValue) setValue(inputValue.toString())
    else setValue('')
  }, [inputValue])

  useEffect(() => {
    setLabelInput(label)
  }, [label])

  return (
    <div className={wrapperClass ? wrapperClass : 'field-wrapper'}>
      <Tooltip
        arrow
        className='tooltip-error-input'
        title={errorText || ''}
        open={validateField && errorText ? true : false}
      >
        <FormControl error={validateField} sx={{width: '100%'}}>
          <CustomInputLable id={id} htmlFor={id} aria-label='test'>
            {labelInput}
            {required && <span className='input-require'> *</span>}
          </CustomInputLable>
          <CustomInputField
            label={labelInput}
            key={id}
            id={id}
            type='text'
            name={name}
            className={inputClass}
            placeholder={placehoder}
            value={value}
            onChange={(e) =>
              formatCurrency ? handleChangeData(reformatText(e)) : handleChangeData(e)
            }
            onBlur={(e) => handleSaveData(e)}
            inputProps={{maxLength: maxLength}}
            size='small'
            autoComplete='off'
            fullWidth
            error={validateField}
            InputProps={{
              readOnly: inputReadonly,
              disabled: inputReadonly,
            }}
            styleprops={{uppercase: inputUppercase ? 'uppercase' : 'none'}}
          />
        </FormControl>
      </Tooltip>
    </div>
  )
}
